// MundialAddonHeader/index.jsx
import React from 'react';
import { useSelector } from 'react-redux';
import styles from './styles.module.scss';
import { getBrandHeaderAsset } from 'utils/getAddonHeader';

const VARIANTS = [
  { suffix: 'smalltap', media: '(max-width: 595px)' },
  { suffix: 'tabletportrait', media: '(max-width: 795px)' },
  { suffix: 'windows800', media: '(max-width: 1029px)' },
  { suffix: 'tabletlandscape', media: '(max-width: 1355px)' },
  { suffix: 'mediumcursor', media: '(max-width: 1919px)' },
];

const MundialAddonHeader = () => {
  const assets = useSelector(state => state.asset);

  const fallback = getBrandHeaderAsset(assets, 'medium1920');

  return (
    <picture>
      {VARIANTS.map(({ suffix, media }) => {
        const src = getBrandHeaderAsset(assets, suffix);
        if (!src) return null;
        return <source key={suffix} media={media} srcSet={src} />;
      })}
      <img
        className={styles.MundialAddonHeader}
        alt="mundial2026"
        src={fallback}
      />
    </picture>
  );
};

export default MundialAddonHeader;